import {
  CompleteInteractiveAuthResponseEnum,
  purchaseApi,
  type Success,
} from "@b2bportal/purchase-api";
import {
  type CartContext,
  CartFulfillErrorModal,
  CartFulfillState,
} from "@checkout/index";
import {
  getCartFulfillCompleteInteractive,
  getFulfillCipherText,
} from "@checkout/states/Cart/CartFulfill/selectors";
import { axiosInstance } from "@hopper-b2b/api";

export const completeInteractiveFulfillService = async (
  context: CartContext,
  _event: unknown
) =>
  new Promise<Success>((resolve, reject) => {
    const req = {
      ...getCartFulfillCompleteInteractive({ context }),
      token: getFulfillCipherText({ context }),
    };

    try {
      purchaseApi(axiosInstance)
        .apiV1PurchaseFulfillCompleteInteractiveAuthPut(req)
        .then((r) => r.data)
        .then((res) => {
          if (
            res.CompleteInteractiveAuthResponse ===
            CompleteInteractiveAuthResponseEnum.Success
          ) {
            resolve(res);
          } else {
            reject({
              failedAt: CartFulfillState.completeInteractive,
              data:
                res.CompleteInteractiveAuthResponse ===
                CompleteInteractiveAuthResponseEnum.Failure
                  ? res.errors
                  : undefined,
              // TODO better error type by reading res.errors
              type: CartFulfillErrorModal.Unknown,
            });
          }
        });
    } catch (e) {
      reject({
        failedAt: CartFulfillState.completeInteractive,
        type: CartFulfillErrorModal.Unknown,
        data: e,
      });
    }
  });
